// ----------------------------------------------------------------------
// <copyright file="Izenda.Tracker.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import mixin from '../utils/Izenda.Mixin';
/**
 * Change tracker decorator
 */
let tracker = mixin({
  resetDirty() {
    this.isDirty = false;
  },
  markDirty() {
    this.isDirty = true;
  }
});

/**
 * Decorator "dirty" for class methods. Automatically calls markDirty() after the method execution
 */
export function dirty(_target, _name, descriptor) {
  const original = descriptor.value;
  if (typeof(original) === 'function') {
    descriptor.value = function(...args) {
      const result = original.apply(this, args);
      this.markDirty();
      return result;
    }
  }
  return descriptor;
}

export default tracker;


// WEBPACK FOOTER //
// ./ui/share/tracking/Izenda.Tracker.js